import { colors } from '@/styles';

export const COUNT_MODES = {
    ENTIRE_WAREHOUSE: 'ENTIRE_WAREHOUSE',
    SPECIFIC_BINS: 'SPECIFIC_BINS',
    SPECIFIC_SHIPPERS: 'SPECIFIC_SHIPPERS',
};

export const ASSIGNABLE_CYCLE_COUNT_ROLES = ['warehouse', 'admin', 'operations'];

// Neutral grey for unknown / not-yet-started statuses (no design token equivalent).
export const STATUS_NEUTRAL = '#9e9e9e';

export const CYCLE_COUNT_STATUS_LABELS = {
    NEW: { label: 'New', color: STATUS_NEUTRAL },
    IN_PROGRESS: { label: 'In Progress', color: colors.oranges.primary },
    COMPLETED: { label: 'Completed', color: colors.greens.primary },
    CANCELED: { label: 'Canceled', color: colors.reds.cancelled },
};
